<template>
  <vs-popup
    title="Select a table"
    @close="handlePopupClose"
    :active.sync="showThisPopup"
    class="select-table-popup"
  >
    <vs-row v-for="table in tables" :key="'selectTableRow-' + table.table.id">
      <vs-col>
        <vs-card>
          <div slot="header">
            <h6>{{ table.table.name }} ({{ table.table.seatCount }} seats)</h6>
          </div>
          <vs-row>
            <vs-chip v-if="table.table.isReservedForWalkIns()" color="primary">Reserved for walk-ins</vs-chip>
            <vs-chip v-if="!table.table.isActive"><vs-avatar icon="build" />Not active</vs-chip>
          </vs-row>
          <vs-row
            vs-w="12"
            class="my-2"
          >
            <vs-col vs-w="12">
              Policies from venue:<br /><show-policies-list
                :object-with-policies="venue"
              />
            </vs-col>
          </vs-row>
          <vs-row
            vs-w="12"
            class="my-2"
          >
            <vs-col vs-w="12">
              Policies from setup:<br /><show-policies-list
                :object-with-policies="setup"
              />
            </vs-col>
          </vs-row>
          <vs-row
            vs-w="12"
            class="my-2"
          >
            <vs-col vs-w="12">
              Policies from section:<br /><show-policies-list
                :object-with-policies="section"
              />
            </vs-col>
          </vs-row>
          <vs-row
            vs-w="12"
            class="my-2"
          >
            <vs-col vs-w="12">
              Policies on table:<br /><show-policies-list
                :object-with-policies="table.table"
              />
            </vs-col>
          </vs-row>
          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button color="primary" @click="handleTableSelectClick(table)"
                >Select</vs-button
              >
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
import ShowPoliciesList from "@/views/modules/marcom/components/policies/ShowPoliciesList.vue";

export default {
  components: {
    ShowPoliciesList,
  },
  data() {
    return {
      venue: undefined,
      setup: undefined,
      section: undefined,
      tables: [],
      showThisPopup: false,
    };
  },
  computed: {},
  methods: {
    show(venue, setup, section, tables) {
      this.venue = venue;
      this.setup = setup;
      this.section = section;
      this.tables = tables;
      this.showThisPopup = true;
    },
    async handleTableSelectClick(table) {
      this.$emit("table-selected", table);

      setTimeout(() => {
        this.handlePopupClose();
      }, 50);
    },
    handlePopupClose() {
      this.venue = undefined;
      this.setup = undefined;
      this.section = undefined;
      this.tables = [];
      this.showThisPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.select-table-popup::v-deep {
z-index: 56000;
 .vs-popup {
  width: 780px;
 }
}
</style>
